export default __webpack_public_path__ + "static/DTC_Image_Cart_DBVeritor_COVIDTest-663d6381f8d1333db297ac1d2f204726.png";